<script setup lang="ts">
import type { CardFragment } from '#graphql-operations'

interface CardProps {
  data: CardFragment
}

const props = defineProps<CardProps>()
const colorScheme = useColorScheme(() => props.data.colorScheme)
</script>

<template>
  <div class="card flex gap-4" :class="[colorScheme, data.textPosition === 'bottom' ? 'flex-col lg:flex-col' : 'flex-col lg:flex-col-reverse']">
    <div class="rounded-2.5 bg-$color-scheme-background aspect-4/3 of-hidden">
      <CraftSvg v-for="media in data.media" :key="media!.id" class="size-full object-cover" :media />
    </div>
    <Text v-if="data.heading" class="richtext-card c-$color-scheme-foreground" :html="data.heading" />
  </div>
</template>

<style scoped>
.richtext-card {
  font-family: var(--font-serif);
  font-size: 9vw;
  line-height: 1;
  text-align: center;

  @screen lt-lg {
    & :deep(> span:first-child) {
      display: inline-block;
      margin-right: 4vw;
    }

    & :deep(a + span) {
      display: block;
      margin-left: 18vw;
    }
  }

  @screen lg {
    font-size: 3.8vw;
  }
}
</style>
